
export default function initializeReadMoreApp(button) {
    button.addEventListener('click', (event) => {
        let parentClassList = event.target.parentNode.classList;
        parentClassList.remove('TextContentOverflowHidden');
        event.target.style.display = 'none';
    });
}


// WEBPACK FOOTER //
// ./src/apps/ReadMoreApp.js